import analytics from '../utils/cdpAnalytics'

export function clearUserAndSendToLogin(dispatch) {
  clearCurrentUser(dispatch)
  // /confirm-email-update confirms an email change that invalidates all
  // sessions, so the user's still-open tab often holds a token that's about
  // to (or just did) stop working. If that causes a 401 here, skip the
  // redirect so they stay on the page and see the confirmation result
  // instead of being bounced to /login mid-flow.
  if (window.location.pathname.startsWith('/confirm-email-update')) return
  window.location = '/login'
}

function clearCurrentUser(dispatch) {
  // TODO: check and list all user-related localStorage items here
  localStorage.removeItem('ls.session')
  localStorage.removeItem('plickers-tab-sync')
  localStorage.removeItem('service.product')
  localStorage.removeItem('meta.setGroup')
  localStorage.removeItem('lastViewedDiscover')
  localStorage.removeItem('recentSearchQueries')
  dispatch({ type: 'LOGOUT' })
  // remove user from analytics tracking
  analytics.reset()
}
